exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon-home:before{content:\"\\E800\"}.home-button{position:absolute;overflow:hidden;left:1em;top:.2em;font-size:1.5em;background:Transparent no-repeat;border:none;outline:none;cursor:pointer;color:#fff}.home-button:focus{outline:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15142080","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Play.vue
// module id = 19
// module chunks = 0